import { render, staticRenderFns } from "./uploadInvoice.vue?vue&type=template&id=1a59d759&scoped=true"
import script from "./uploadInvoice.vue?vue&type=script&lang=ts"
export * from "./uploadInvoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59d759",
  null
  
)

export default component.exports